import { Hall } from '@weblite/ts-action/hall'
import hostConf from '$config/frontend'

export const getHallPublicLink = (hall: Hall | undefined) => {
  if (!hall) return null
  const { identifier, public: isPublic } = hall
  return identifier && isPublic ? `${hostConf.FRONT_HOST}/${identifier}` : null
}
